import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails"
import style from "./style.module.scss"
import { CraftService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";

type storageCraftDetailType = {
  initialValue: any
}

const StorageCraftDetail = ( {initialValue}: storageCraftDetailType) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"].split("/").pop();

  useEffect(() => {
    id && getStorageCraft(id);
  }, [initialValue]);

  const getStorageCraft = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await CraftService.getCraftById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

const renderValue = (value : any /* string | number | boolean */) => {
  return value ? value : "-";
};

  return (
    <div>
      <Loader isLoading={isLoading}/>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Nom : </span>
                <span className={style.details__value}>{renderValue(data?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type : </span>
                <span className={style.details__value}>{renderValue(data?.craftType?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Machine : </span>
                <span className={style.details__value}>{renderValue(data?.engine)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Volume : </span>
                <span className={style.details__value}>{renderValue(data?.volume)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage (T) : </span>
                <span className={style.details__value}>{renderValue(data?.tonnage)}</span>
              </div>
            </CardDetails>
    </div>
  )
}

export default StorageCraftDetail